export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGIN_RESET = 'LOGIN_RESET';
export const REFRESH_TOKEN_REQUEST = 'REFRESH_TOKEN_REQUEST';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_SHOW_TRIAL_POPUP = 'SET_SHOW_TRIAL_POPUP';
export const GET_GLOBAL_FEATURES_REQUEST = 'GET_GLOBAL_FEATURES_REQUEST';
export const GET_GLOBAL_FEATURES_SUCCESS = 'GET_GLOBAL_FEATURES_SUCCESS';
